import {gql} from "@apollo/client";
import filterDataGql, { executeQueryUtil } from '../utils/gqlUtil';
import apolloClient from "../apolloClient/ApolloClient";

/**
 * 📊 SumUpMonthGql - Query pour récupérer les données agrégées d'un mois
 *
 * ⚠️ IMPORTANT: Les données retournées sont COMPRESSÉES en Base64
 *
 * Usage pour décompression:
 * ```javascript
 * import {decompressFromBase64} from "../utils/compressUtil";
 *
 * const result = await executeQueryUtil(getSumUpMonthQuery(brandId, establishmentId, monthKey));
 *
 * // 🔍 OBLIGATOIRE: Décompresser le contenu avant utilisation
 * let content = result?.data?.getSumUpMonth?.content;
 * content = content && decompressFromBase64(content);
 * const parsed = content ? JSON.parse(content) : null;
 *
 * // 📈 Accès aux données
 * const totalTurnover = parsed?.totalTurnover || 0;
 * const detailbyStaff = parsed?.detailbyStaff || [];
 * const totalOrders = parsed?.totalOrders || 0;
 * const averageTicket = parsed?.averageTicket || 0;
 * ```
 *
 * 📅 Format monthKey attendu: "YYYY-M##-DD-MM" (ex: "2024-M03-31-03")
 * - YYYY: Année
 * - M##: Mois (01-12)
 * - DD-MM: Dernier jour du mois et numéro du mois
 */

const common = `
  id
  content
  dayDate
`

/**
 * 🔧 Génère une query GraphQL pour récupérer les données d'un mois spécifique
 *
 * @param {string} brandId - ID de l'enseigne
 * @param {string} establishmentId - ID de l'établissement
 * @param {string} month - Clé du mois au format "YYYY-M##-DD-MM"
 * @returns {DocumentNode} Query GraphQL prête à être exécutée
 *
 * 💡 Exemple d'usage:
 * ```javascript
 * const monthKey = "2024-M03-31-03"; // Mars 2024
 * const query = getSumUpMonthQuery("brandId123", "establishmentId456", monthKey);
 * const result = await executeQueryUtil(query);
 * ```
 *
 * 🔄 Utilisé pour les comparaisons mensuelles:
 * - Mois actuel vs mois précédent
 * - Évolution du chiffre d'affaires mensuel
 * - Analyses de tendances mensuelles
 */
export const getSumUpMonthQuery = (brandId, establishmentId, month) => {
  var debug = `
    query {
      getSumUpMonth(brandId: "${brandId}", establishmentId: "${establishmentId}", sumUpMonthId:"${month}") {
        ${common}
      }
    }
  `
  console.log("📊 SumUpMonth Query:", debug);

  return gql`
    query {
      getSumUpMonth(brandId: "${brandId}", establishmentId: "${establishmentId}", sumUpMonthId:"${month}") {
        ${common}
      }
    }
  `;
}






